import type { Episode } from "@supermanus/document-model";
import { parseItemNumber } from "@supermanus/document-model";
import { InlineEditable } from "./InlineEditable";

export function EpisodeTitleLine({
  episode,
  showNumber,
  readOnly,
  onRename,
  onNumberChange,
  className,
  truncate = false,
}: {
  episode: Pick<Episode, "number" | "title">;
  showNumber: boolean;
  readOnly?: boolean;
  onRename?: (title: string) => void;
  onNumberChange?: (number: string) => void;
  className?: string;
  /** Constrain long titles (page bar) instead of growing with content. */
  truncate?: boolean;
}) {
  const titleField = (
    <InlineEditable
      className={["sm-episode-title-text", className].filter(Boolean).join(" ")}
      value={episode.title}
      onChange={(title) => onRename?.(title)}
      readOnly={readOnly || !onRename}
      placeholder="Unavngiven episode"
      title="Klik for at omdøbe episode"
      fill={truncate}
    />
  );
  if (!showNumber) {
    return (
      <span
        className={[
          "sm-episode-title-line",
          "sm-episode-title-line--solo",
          truncate ? "is-truncate" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        {titleField}
      </span>
    );
  }
  return (
    <span
      className={[
        "sm-episode-title-line",
        truncate ? "is-truncate" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="sm-episode-title-prefix">
        Episode{" "}
        {onNumberChange && !readOnly ? (
          <InlineEditable
            as="span"
            className="sm-episode-num-value"
            value={String(episode.number)}
            title="Klik for at ændre episodenummer"
            onChange={(raw) => {
              const parsed = parseItemNumber(raw);
              if (parsed && parsed !== String(episode.number)) {
                onNumberChange(parsed);
              }
            }}
          />
        ) : (
          episode.number
        )}
        {": "}
      </span>
      {titleField}
    </span>
  );
}
